import React from 'react';
import { motion } from 'framer-motion';

// We use initial={{ opacity: 1 }} to ensure Lighthouse and slow-loading 
// environments don't see a blank screen while waiting for JS animations.
export const Display = ({ children, className = "", as: Component = "h1", ...props }) => (
  <Component className={`font-serif text-5xl md:text-7xl lg:text-8xl xl:text-9xl leading-[0.9] tracking-tight ${className}`} {...props}>
    {children}
  </Component>
);

export const Heading = ({ children, className = "", as: Component = "h2", ...props }) => (
  <Component className={`font-serif text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight ${className}`} {...props}>
    {children}
  </Component>
);

export const Subheading = ({ children, className = "", as: Component = "h3", ...props }) => (
  <Component className={`font-sans text-xl md:text-2xl lg:text-3xl font-light leading-snug ${className}`} {...props}>
    {children}
  </Component>
);

export const Body = ({ children, className = "", large = false, ...props }) => (
  <p className={`font-sans ${large ? 'text-lg md:text-xl' : 'text-base md:text-lg'} leading-relaxed opacity-80 ${className}`} {...props}>
    {children}
  </p>
);

export const Label = ({ children, className = "", ...props }) => (
  <span className={`font-sans text-xs uppercase tracking-widest font-semibold ${className}`} {...props}>
    {children}
  </span>
);